import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { SocialMediaComponent } from '@shared/social-media/social-media.component';

@Component({
    selector: 'companyid-title-with-social-media[title][subtitle]',
    imports: [ContentWrapperComponent, SocialMediaComponent],
    templateUrl: './title-with-social-media.component.html',
    styleUrl: './title-with-social-media.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleWithSocialMediaComponent {
    public title = input.required<string>();
    public subtitle = input.required<string>();

    public readonly lastUpdated = $localize`:@@last-updated:Last updated: July 1, 2024`;
}
